// extracted by mini-css-extract-plugin
export var section = "_2q-1";
export var topNav = "_2q-0";